<template>
  <svg
    class="animate-spin stroke-current"
    width="22"
    height="22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="11" cy="11" r="9" stroke-opacity=".5" stroke-width="3" />
    <path stroke-width="3" d="M20 11a9 9 0 0 0-9-9" />
  </svg>
</template>
